if (!customElements.get('count-down')) {
  customElements.define('count-down', class Countdown extends HTMLElement {
    constructor() {
      super();
      
      this.endDate = this.hasAttribute('end-date') ? new Date(this.getAttribute('end-date')).toUTCString() : Date.now().toUTCString();
      this.timeElement = document.createElement('time');

      this.init();
    }

    init () {
      const countdownTime = this.getCountdownTime(this.endDate);
      const countdownUnits = Object.keys(countdownTime);

      this.append(this.timeElement);

      countdownUnits.slice(1).forEach((countdownUnit) => {
        this.timeElement.appendChild(this.createCountdownItem(countdownUnit, countdownTime[countdownUnit]));
      });

      if (countdownTime.total > 0) {
        this.timeInterval = setInterval(() => {
          this.renderCountdown(this.getCountdownTime(this.endDate));
        }, 1000);
      } else {
        this.setAttribute('data-ended', 'true');
        document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id}`));
      }
    }

    createCountdownItem(key, value) {
      const countdownItem = document.createElement('span');
      const timeLeft = document.createElement('span');
      const unit = document.createElement('span');

      countdownItem.className = 'count-down__item';
      timeLeft.className = `count-down__number ${key}`;
      timeLeft.textContent = value;
      unit.textContent = key;
      unit.className = 'count-down__unit';

      countdownItem.appendChild(unit);
      countdownItem.appendChild(timeLeft);

      return countdownItem;
    }

    getCountdownTime(endDate) {
      const total = Date.parse(endDate) - Date.parse(new Date().toUTCString());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      };
    }

    renderCountdown(countdownTime) {
      const daysElement = this.querySelector('.days');
      const hoursElement = this.querySelector('.hours');
      const minutesElement = this.querySelector('.minutes');
      const secondsElement = this.querySelector('.seconds');

      daysElement.textContent = countdownTime.days;
      hoursElement.textContent = countdownTime.hours;
      minutesElement.textContent = countdownTime.minutes;
      secondsElement.textContent = countdownTime.seconds;

      this.timeElement.setAttribute('datetime', `P${countdownTime.days}DT${countdownTime.hours}H${countdownTime.minutes}M${countdownTime.seconds}S`);

      if (countdownTime.total <= 0) {
        clearInterval(this.timeInterval);
        this.setAttribute('data-ended', 'true');
        document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id}`));
      }
    }
  });
}